import { Token } from '@/utils/mm'
import klineApi from "@/api/kline";

export const webSocketMixin = {
    data() {
        return {
            isWebsock: false,
            websock: null, // 他这里应该少定义了一个对象
            websockTime: "", //心跳
            channelToSubscription: new Map() // 不同的订阅频道
        }
    },
    created() {
        // this.webSocketInit(); // 直接初始化websocket对象
    },
    methods: {
        /**
         * 这里其实是初始化了websocket对象
         * e {string} load=加载 get=获取
         */
        webSocketInit() {
            const self = this;
            if (typeof WebSocket === "undefined") {
                alert("Your browser does not support websocket");
            } else {
                try {
                    this.websockClose();
                } catch (e) {
                    console.log(e)
                }
                // 实例化socket
                const wsUrl = window.websocketUrl + "?Authorization=Bearer " + Token.get();// 让每个请求携带自定义token 请根据实际情况自行修改
                self.websock = new WebSocket(wsUrl);
                // 监听socket连接
                self.websock.onopen = self.websockOpen;
                // 监听socket错误信息
                self.websock.onerror = self.websockError;
                // 监听socket消息
                self.websock.onmessage = self.websockMessage;
                // 关闭socket连接
                self.websock.onclose = self.websockClose;
            }
        },
        //打开websocket连接
        websockOpen(e) {
            const self = this;
            console.log("socket连接成功");
            if (this.websockTime) {
                clearInterval(this.websockTime);
            }
            this.isWebsock = true;
            // 开启心跳
            setTimeout(function () {
                self.websockHeartbeat();
            }, 1000);
        },
        //发送消息
        websockSend(msg) {
            const self = this;
            if (this.isWebsock) {
                console.log("发送socket消息:", msg);
                self.websock.send(msg);
            }
        },
        //错误
        websockError(e) {
            // console.log(e)
            //   console.log("连接错误");
            this.websockClose();
        },
        //监听返回消息
        websockMessage(msg) {
            const self = this;
            // console.log('messageTV', msg.data);
            // 这里订阅的时候只会返回一个产品的行情
            let quotes = JSON.parse(msg.data);
            if (!quotes || quotes.length == 0) {
                return;
            }
            const {
                // TYPE: eventTypeStr,
                Symbol: symbol,
                Date: tradeTimeStr,
                NewPrice: tradePriceStr,
                Volume: volume
            } = quotes[0];

            const tradePrice = parseFloat(tradePriceStr);
            const tradeTime = parseInt(tradeTimeStr) * 1000; // 转换为毫秒
            let channelString = '';
            for (let key of self.channelToSubscription.keys()) {
                if (key.indexOf(symbol) >= 0) {
                    channelString = key;
                    break;
                }
            }

            const subscriptionItem = self.channelToSubscription.get(channelString);
            if (subscriptionItem === undefined || Object.keys(subscriptionItem.lastDailyBar).length === 0) {
                return;
            }

            const lastDailyBar = subscriptionItem.lastDailyBar;
            const nextDailyBarTime = self.getNextDailyBarTime(lastDailyBar);
            const resolution = lastDailyBar.resolution;
            
            let bar;
            if (tradeTime >= nextDailyBarTime) {
                // 重新请求一次k线,获取指定时间的k线数据
                const urlParameters = {
                    symbol: symbol,
                    st: nextDailyBarTime / 1000,
                    line: resolution
                }
                klineApi.getKline(urlParameters).then(response => {
                    // console.log('Generate new bar data', response.data);
                    let newBar = response.data;
                    bar = {
                        time: nextDailyBarTime, // K线时间必须以毫秒为单位  
                        low: newBar.low,
                        high: newBar.high,
                        open: newBar.open,
                        close: newBar.close,
                        volume: newBar.volume,
                        resolution: resolution
                    }
                    subscriptionItem.lastDailyBar = bar;
                    // 最终的回调在这里,这里会去更新新tv图上的数据
                    // Send data to every subscriber of that symbol
                    subscriptionItem.handlers.forEach((handler) => handler.callback(bar));
                    console.log('[socket] Generate new bar', bar);
                });

            } else {
                if (tradeTime != lastDailyBar.time) {
                    bar = {
                        ...lastDailyBar,
                        high: Math.max(lastDailyBar.high, tradePrice),
                        low: Math.min(lastDailyBar.low, tradePrice),
                        close: tradePrice,
                        // volume: volume, // 这里可以只更新价格,成交量不更新
                        resolution: resolution
                    };
                    console.log('[socket] Update the latest bar', bar);
                    subscriptionItem.lastDailyBar = bar;
                    // 最终的回调在这里,这里会去更新新tv图上的数据
                    // Send data to every subscriber of that symbol
                    subscriptionItem.handlers.forEach((handler) => handler.callback(bar));
                }
            }
        },
        //心跳
        websockHeartbeat() {
            const self = this;
            self.websockTime = setInterval(function () {
                self.websockSend(JSON.stringify({
                    action: 'ping',
                    content: new Date().getTime()
                }));
            }, 60000);
        },
        //连接关闭
        websockClose() {
            const self = this;
            if (this.isWebsock) {
                self.websock.close();
            }
            clearInterval(this.websockTime);
            this.isWebsock = false;
            console.log("socket已经关闭");
        },
        // 订阅产品信息,,这里多个单个产品多个分辨率会调用多次,每个分辨率都有自己的订阅事件
        subscribeOnStream(
            symbolInfo,
            resolution,
            onRealtimeCallback,
            subscriberUID,
            onResetCacheNeededCallback,
            lastDailyBar
        ) {
            console.log('[开始订阅产品]: ', symbolInfo);
            const self = this;

            // 这一步解析商品全称了
            const channelString = subscriberUID;
            const handler = {
                id: subscriberUID,
                callback: onRealtimeCallback,
            };
            // 这个是订阅对象
            let subscriptionItem = self.channelToSubscription.get(channelString);
            if (subscriptionItem) {
                // Already subscribed to the channel, use the existing subscription
                subscriptionItem.handlers.push(handler);
                return;
            }
            subscriptionItem = {
                subscriberUID,
                resolution,
                lastDailyBar,
                handlers: [handler],
            };
            // 这里把订阅对象放到全局Map里面了,然后给用socket发送消息给服务器
            // 后面在websocket的message里面拿出来做处理了handler.callback代码
            // handler.callback回调就是onRealtimeCallback回调,这样就更新了TV新的K线数据
            self.channelToSubscription.set(channelString, subscriptionItem);
            console.log(
                '[subscribeBars]: Subscribe to streaming. Channel:',
                channelString
            );
            const subRequest = {
                action: 'SubAdd',
                content: [symbolInfo.ticker],
            };
            self.websockSend(JSON.stringify(subRequest));
        },
        // 获取下一根K线生成的开始时间
        getNextDailyBarTime(lastDailyBar) {
            let nextBarTime = null;
            const type = lastDailyBar.resolution;
            const barTime = lastDailyBar.time; // 毫秒级
            // console.log('barTime', barTime);
            if (['1', '5', '15', '30', '60'].includes(type)) {
                const date = new Date(barTime + 60000 * parseInt(type));
                nextBarTime = date.getTime()
            } else if (type == "1D") {
                const date = new Date(barTime);
                date.setDate(date.getDate() + 1);
                nextBarTime = date.getTime();
            }
            // console.log('nextBarTime', nextBarTime);
            return nextBarTime;
        },
        unsubscribeFromStream(subscriberUID) {
            const self = this;
            // Find a subscription with id === subscriberUID
            for (const channelString of self.channelToSubscription.keys()) {
                const subscriptionItem = self.channelToSubscription.get(channelString);
                const handlerIndex = subscriptionItem.handlers.findIndex(
                    (handler) => handler.id === subscriberUID
                );

                if (handlerIndex !== -1) {
                    // Remove from handlers
                    subscriptionItem.handlers.splice(handlerIndex, 1);

                    if (subscriptionItem.handlers.length === 0) {
                        // Unsubscribe from the channel if it was the last handler
                        console.log(
                            '[unsubscribeBars]: Unsubscribe from streaming. Channel:',
                            channelString, self.channelToSubscription
                        );
                        // 切换
                        // let subsymbol = channelString.split('_')[0];
                        // const subRequest = {
                        //     action: 'SubRemove',
                        //     content: [subsymbol],
                        // };
                        // self.websock.send(JSON.stringify(subRequest));
                        self.channelToSubscription.delete(channelString);
                        break;
                    }
                }
            }
        }
    }
}